import { 
  Layout,
  PageHeader,
  Breadcrumb,
  Row,
  Col,
  Steps,
} from "antd";
import React, { Component } from 'react';
import RevisionInfoForm from "./steps/stepOne"
import ReviseSellPriceForm from "./steps/stepTwo"
import ConfirmRevise from "./steps/stepThree"
import { connect } from "react-redux";
import { setRevisionPriceStep, setRevisionPriceId } from '../../store/actions/revisionPrice';

const { Content } = Layout;
const { Step } = Steps;
const steps = [
  {
    title: 'Revision Information',
    stepTitle: 'Revision Information',
    component: <RevisionInfoForm/>,
  },
  {
    title: 'Revise Sell Price',
    stepTitle: 'Sell Price',
    component: <ReviseSellPriceForm/>,
  },
  {
    title: 'Confirm Information',
    stepTitle: 'Confirm',
    component: <ConfirmRevise/>,
  },
];
const routes = () => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Listing",
  },
];

class RevisionBuilder extends Component {
  state = {
    currentStep: 0,
    isCreateRevision: true
  };
  
  async componentWillMount() {
    this.props.setRevisionPriceStep({
      step: 0
    })
    if (this.props.match.params.id) {
      this.setState({isCreateRevision: false})
      this.props.setRevisionPriceId({
        id: Number(this.props.match.params.id)
      })
    } else {
      this.props.setRevisionPriceId({
        id: -1
      })
    }
  }

	componentDidUpdate = async (prevProps, prevState) => {
		if (prevProps.revisionStep !== this.props.revisionStep){
      this.setState({ currentStep: this.props.revisionStep });
		}
  }
  
  render() {
    const { currentStep } = this.state;

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
          <Breadcrumb.Item>{this.state.isCreateRevision ? 'Create New' : 'Edit'} Revision</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>{this.state.isCreateRevision ? 'Create New' : 'Edit'} Revision</h2>} />
        <Layout className="my-layout">
          <Content className="main-container">
            <div className='main-container-inner'>
              <Row type="flex">
                <Col span={12}><h3 style={{ fontWeight: "bold" }}>{steps[currentStep].title}</h3></Col>
                <Col span={12}>
                  <Steps current={currentStep} >
                    {steps.map(item => (
                      <Step key={item.stepTitle} title={item.stepTitle} />
                    ))}
                  </Steps>
                </Col>
              </Row>
              <div className="steps-contents">{steps[currentStep].component}</div>
            </div>
          </Content>
        </Layout>
      </Layout>
    )
  }
}

const mapStateToProps = state => {
	return {
		revisionStep: state.revisionPrice.step
	}
}

const mapDispatchToProps = dispatch => {
	return {
    setRevisionPriceStep: ({step}) => dispatch(setRevisionPriceStep({step})),
    setRevisionPriceId: ({id}) => dispatch(setRevisionPriceId({id}))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(RevisionBuilder);


// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/RevisionBuilder.js